import type { CSSProperties } from 'react'

type ElectronDragHeaderStyle = CSSProperties & {
  WebkitAppRegion: 'drag'
}

export const styles = {
  root: {
    flexShrink: 0,
    width: '100%',
    height: 20,
    backgroundColor: 'red',
    userSelect: 'none',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    zIndex: -1,
    WebkitAppRegion: 'drag',
  } satisfies ElectronDragHeaderStyle,
}
